var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useMemo, useState } from 'react';
import { Card, Button, Table } from 'antd';
import { Bar } from 'react-chartjs-2';
import { useQuery } from '@tanstack/react-query';
import SalesPeriodFilter from '../../dashboard/components/filter/line-chart-filter';
import { fetchRecommendMatchByAge, fetchRecommendMatchByAgeDetail } from '../../cores/api/api-dashboard';
import { formatCountNumber } from '../../utils/format-data';
const AGE_ORDER = ['18-24', '25-34', '35-44', '45-54', '55+'];
export const ChartRecommendMatch = () => {
    const _useState = useState('chart'), _useState2 = _slicedToArray(_useState, 2), viewMode = _useState2[0], setViewMode = _useState2[1];
    const _useState3 = useState({
        mode: 'month',
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1
    }), _useState4 = _slicedToArray(_useState3, 2), filters = _useState4[0], setFilters = _useState4[1];
    const _useQuery = useQuery({
        queryKey: ['recommend-match', filters.mode, filters.year, filters.month, filters.year_from, filters.year_to],
        suspense: true,
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            if (filters.mode === 'month' && filters.month) {
                return yield fetchRecommendMatchByAgeDetail({
                    year: filters.year,
                    month: filters.month
                });
            }
            if (filters.mode === 'range' && filters.year_from != null && filters.year_to != null) {
                return yield fetchRecommendMatchByAge({
                    year_from: filters.year_from,
                    year_to: filters.year_to
                });
            }
            return yield fetchRecommendMatchByAge({
                year: filters.year
            });
        })
    }), data = _useQuery.data;
    const handleFilterChange = value => {
        setFilters(value);
    };
    const chartState = useMemo(() => {
        var _a;
        const recommendMap = new Map();
        const matchMap = new Map();
        ((_a = data === null || data === void 0 ? void 0 : data.data) !== null && _a !== void 0 ? _a : []).forEach(day => {
            day.items.forEach(item => {
                var _a, _b;
                // recommend
                const r = (_a = recommendMap.get(item.key)) !== null && _a !== void 0 ? _a : 0;
                recommendMap.set(item.key, r + item.recommend);
                // match
                const m = (_b = matchMap.get(item.key)) !== null && _b !== void 0 ? _b : 0;
                matchMap.set(item.key, m + item.match);
            });
        });
        return {
            labels: AGE_ORDER,
            recommend: AGE_ORDER.map(k => { var _a; return (_a = recommendMap.get(k)) !== null && _a !== void 0 ? _a : 0; }),
            match: AGE_ORDER.map(k => { var _a; return (_a = matchMap.get(k)) !== null && _a !== void 0 ? _a : 0; })
        };
    }, [data]);
    // ✅ chart
    const chartData = {
        labels: chartState.labels,
        datasets: [{
                label: 'Recommend',
                data: chartState.recommend,
                backgroundColor: '#36cfc9'
            }, {
                label: 'Match',
                data: chartState.match,
                backgroundColor: '#722ed1'
            }]
    };
    const tableData = chartState.labels.map((label, index) => {
        var _a, _b;
        const recommend = (_a = chartState.recommend[index]) !== null && _a !== void 0 ? _a : 0;
        const match = (_b = chartState.match[index]) !== null && _b !== void 0 ? _b : 0;
        const rate = recommend > 0 ? Number((match / recommend * 100).toFixed(1)) : 0;
        return {
            key: label,
            label,
            recommend,
            match,
            rate
        };
    });
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top'
            }
        },
        scales: {
            x: {
                grid: {
                    display: false
                }
            },
            y: {
                beginAtZero: true,
                ticks: {
                    precision: 0
                }
            }
        }
    };
    const tableColumns = [{
            title: '年代',
            dataIndex: 'label'
        }, {
            title: 'Recommend',
            dataIndex: 'recommend',
            render: v => formatCountNumber(v)
        }, {
            title: 'Matching',
            dataIndex: 'match',
            render: v => formatCountNumber(v)
        }, {
            title: 'マッチ率',
            dataIndex: 'rate',
            render: v => `${v}%`
        }];
    return /*#__PURE__*/ React.createElement(Card, {
        title: "\u5E74\u4EE3\u5225\u30EC\u30B3\u30E1\u30F3\u30C9\u6570\u3068\u30DE\u30C3\u30C1\u6570",
        extra: /*#__PURE__*/ React.createElement("div", {
            className: "flex items-center gap-4"
        }, /*#__PURE__*/ React.createElement(SalesPeriodFilter, {
            enableYearRange: true,
            onChange: handleFilterChange
        }), /*#__PURE__*/ React.createElement("div", {
            className: "flex gap-2"
        }, /*#__PURE__*/ React.createElement(Button, {
            onClick: () => setViewMode('chart'),
            className: viewMode === 'chart' ? '!bg-[#f0c52a36]' : ''
        }, "\u30B0\u30E9\u30D5"), /*#__PURE__*/ React.createElement(Button, {
            onClick: () => setViewMode('table'),
            className: viewMode === 'table' ? '!bg-[#f0c52a36]' : ''
        }, "\u8868"))),
        styles: {
            body: {
                paddingTop: '4px',
                height: 400,
                display: 'flex',
                flexDirection: 'column'
            }
        }
    }, viewMode === 'chart' ? /*#__PURE__*/ React.createElement("div", {
        style: {
            flex: 1,
            width: '100%'
        }
    }, /*#__PURE__*/ React.createElement(Bar, {
        data: chartData,
        options: options
    })) : /*#__PURE__*/ React.createElement(Table, {
        key: `${filters.mode}-${filters.year}-${filters.month}-${filters.year_from}-${filters.year_to}`,
        rowKey: "key",
        columns: tableColumns,
        dataSource: tableData,
        pagination: false,
        scroll: {
            y: 345
        },
        locale: {
            emptyText: 'データがありません'
        }
    }));
};
